import { forwardRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CurrenciesEnableBlock } from './CurrenciesEnable';
import { CurrenciesAvailableBlock } from './CurrenciesAvailable';
import { ModalDefaultProps } from 'components/Modal';
import { ModalTemplate } from 'components/ModalTemplate';
import { Button } from 'components/buttons';
import { ModalTemplateSettings } from 'components/ModalTemplate/types';

import {
  ScEditCurrenciesModalContainer,
  ScTitleEditCurrencies,
} from './styled';
import { useMedia } from 'modules/common/hooks/useMedia';

export const EditCurrencies = forwardRef<HTMLDivElement, ModalDefaultProps>(
  ({ onClose }, ref) => {
    const { t } = useTranslation(['deposits', 'glossary']);
    const { isMobileS } = useMedia();

    const modalSettings: ModalTemplateSettings = useMemo(
      () =>
        isMobileS
          ? {
              type: 'mobile',
              mode: {
                type: 'bottom',
              },
              smallXPadding: true,
            }
          : {
              type: 'desktop',
              size: 'small',
              mode: {
                type: 'default',
              },
            },
      [isMobileS]
    );

    const buttonSettings = useMemo(
      () => (isMobileS ? { wide: true } : { _width: 232 }),
      [isMobileS]
    );

    return (
      <ModalTemplate
        ref={ref}
        onClose={onClose}
        settings={modalSettings}
        title={isMobileS ? t('deposits:editCurrency.title') : undefined}
      >
        <ScEditCurrenciesModalContainer>
          {!isMobileS && (
            <ScTitleEditCurrencies>
              {t('deposits:editCurrency.title')}
            </ScTitleEditCurrencies>
          )}
          <CurrenciesEnableBlock />
          <CurrenciesAvailableBlock />
          <div className="btn">
            <Button
              xLarge
              whiteTransparent
              {...buttonSettings}
              onClick={onClose}
            >
              {t('glossary:back')}
            </Button>
          </div>
        </ScEditCurrenciesModalContainer>
      </ModalTemplate>
    );
  }
);
